import React,{useState,useMemo} from 'react';
import {DialogContent,Paper,Dialog,CircularProgress,Tooltip,Typography,IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import Draggable from 'react-draggable';
import { useStyles, paperPropsSmallF} from '../../../css/muiStyle';
import DataTable from "react-data-table-component";
import $ from 'jquery'
import ParamContext from '../../../Contexte';
import { useContext } from 'react';
import {ReactComponent as Stock} from '../../../img/icons/stock.svg'
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles} from '@material-ui/core/styles';
import { mdiDetails } from '@mdi/js';
import Icon from '@mdi/react';
import {customStyles} from '../../../css/datatable-custom'
import "../../../css/referentiel.css"

const styles = (theme) => ({
  root: {
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top:0,
    color:'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle  className={classes.root} {...other}>
      <Typography >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

//add new marque
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function Ref_prd_detail_stk(props) {
    const Gfunc=require('../../../Gfunc')
    const param=useContext(ParamContext);
    const [open, setOpen] =useState(false);
    const classes=useStyles();
    const [data, setData] =useState([]);
    const service='_prd.php'

    $(function() {
      $("div").removeAttr("data-tag")
    })  

    const handleClickOpen = () => { 
      setOpen(true); 
      setData([]);
      fetch();
    };

    const handleClose = () => { setOpen(false); };

    const fetch=async()=>{
      const response=await Gfunc.axiosPostAction(service,"getstkbyloc",{produitId:parseInt(props.row.DT_RowId.substr(1))})
      if(response.data.err&&response.data.err!=="-1"){
          props.handleAlert(true,"error",response.data.err)
      }else
          Gfunc.axiosResponse(response,()=>{
             if(response.data.jData&&response.data.jData.length>0){
              let dat =[...response.data.jData]
              if(Number.isInteger(props.stk))
              dat=Gfunc.removeItemsExcept(dat,props.stk,"stockId")
              setData(dat)
            }
       })
    }

    const columns =useMemo(
        () => [ 
          {
            name: "Stock",
            selector: row=>row.stock,
            minWidth:"280px !important",
            sortable: true, 
          },
          {
            name: "QTE.",
            selector: row=>row.qte,
            minWidth:"120px !important",
            sortable: true,
          },
        ],[]);

  return (
    <div>
       <Tooltip title="Détail du stock du produit"> 
         <Stock fill='#ffa000' style={{height:'20px',width:'20px',padding:"1px"}}   onClick={handleClickOpen}/>
       </Tooltip>
       <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperPropsSmallF}
      >
            <DialogTitle className={classes.topDivTitle} onClose={handleClose} >
              <div className='DialogTitle'>
                <Icon path={mdiDetails} size={1} />
                <label>Détail du stock de {props.row.produit}</label>
              </div>
            </DialogTitle>
            <DialogContent >
                   <DataTable
                      columns={columns}
                      data={data}
                      noDataComponent={param.ErreurData}
                      defaultSortAsc={true}
                      pagination
                      paginationRowsPerPageOptions={[5, 10, 20, 30]}
                      highlightOnHover
                      customStyles={customStyles}
                      selectableRowsComponentProps={{ className: classes.checkStelect }}
                      paginationComponentOptions={{ rowsPerPageText: 'Élément par page:', rangeSeparatorText: 'sur', selectAllRowsItemText: 'Tous',selectAllRowsItem: true}}
                      contextMessage={{ singular: 'élément sélectionné', plural: 'éléments sélectionnés' }}
                      progressComponent={<CircularProgress className="circularProgress" />}
                   />
            </DialogContent>
      </Dialog>
      </div>
  );
}